import { NavigateBefore, NavigateNext } from "@mui/icons-material";
import { Divider, IconButton, Stack, Tab, Tabs, useMediaQuery, useTheme } from "@mui/material"
import { useEffect, useRef, useState } from "react"
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import NullCheck from "./NullCheck";
import { useSelector } from "react-redux";
import useCheckData from "hooks/CheckData";
import { useBizType } from "hooks/useBizType";

const CustomTabs = ({
    tabList,
    callBackFunc,
    showScrollBtn,
    sticky = false,
    divider = false,
    defaultValue = 0,
    variant,
    sx,
}) => {
    const theme = useTheme()
    const { bt } = useBizTypeTranslation();
    const tabsRef = useRef(null)
    const { hasPlugin } = useCheckData();
    const { bizTypeCheck } = useBizType()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const userRole = useSelector((state) => state.userSettings?.user?.userRole);
    const [selectedTab, setSelectedTab] = useState(null)
    const [list, setList] = useState([])

    useEffect(() => {
        if (defaultValue)
            setSelectedTab(defaultValue)
    }, [defaultValue]);

    useEffect(() => {
        if (tabList.length > 0) {
            let newList = []
            const list = tabList?.filter(btn => !btn.hide && (!btn.showRoles || btn.showRoles.includes(userRole)))

            list?.forEach(tab => {
                const plugin = hasPlugin(tab.pluginName);
                const bizType = bizTypeCheck(tab.bizType);
                if ((!tab.pluginName || plugin) && (!tab.bizType || bizType))
                    newList.push(tab)

            });

            setList(newList)
        }
    }, [tabList])

    useEffect(() => {
        if (list.length > 0 && selectedTab === null) {
            setSelectedTab(list[0]?.id)
        }
    }, [list]);

    useEffect(() => {
        if (selectedTab !== null && tabsRef.current) {
            const activeTab = tabsRef.current.querySelector('[aria-selected="true"]');
            if (activeTab) {
                activeTab.scrollIntoView({ behavior: 'smooth', inline: 'center' });
            }
        }
    }, [selectedTab]);

    const onSelect = (event, newValue) => {
        setSelectedTab(newValue)
        if (callBackFunc)
            callBackFunc(newValue)
    }

    const handleScroll = (direction) => {
        const firstItemId = list[0]?.id
        const LastItemId = list[list?.length - 1]?.id
        if (direction === 'left' && selectedTab < LastItemId)
            onSelect(null, selectedTab + 1)
        else if (direction === 'right' && selectedTab > firstItemId)
            onSelect(null, selectedTab - 1)
    };

    return (
        list.length > 1
            ? <Stack
                width='100%'
                position={sticky ? 'sticky' : 'none'}
                zIndex={sticky ? 999 : 0}
                top={0}
            >

                <Stack
                    width="100%"
                    direction='row'
                    justifyContent='space-between'
                    alignItems='center'
                >
                    <NullCheck valueForCheck={showScrollBtn && isMobile}>
                        <IconButton width='100%' size="small" onClick={() => handleScroll('right')}>
                            <NavigateNext />
                        </IconButton>
                    </NullCheck>

                    <Tabs
                        onChange={onSelect}
                        variant={variant}
                        scrollButtons={variant === 'scrollable' ? 'auto' : undefined}
                        allowScrollButtonsMobile={variant === 'scrollable'}
                        ref={tabsRef}
                        value={selectedTab ?? false}
                        TabIndicatorProps={{ style: { display: 'none' } }}
                        sx={{
                            minWidth: variant === 'scrollable' ? 0 : undefined,
                            width: variant === 'scrollable' ? '100%' : undefined,
                            minHeight: 30, // גובה כולל של כל שורת הטאבים
                            height: 30,
                            '& .MuiTab-root': {
                                minHeight: 30,  // גם לטאבים עצמם
                                paddingY: 0,    // ביטול מרווחים אנכיים
                                paddingX: 1,    // אפשר להקטין גם את הרוחב אם רוצים
                            },
                            ...sx,
                        }}
                    >
                        {list?.map(tab => {
                            return (
                                tab?.show === undefined || tab?.show
                                    ? <Tab
                                        key={tab?.id}
                                        value={tab?.id}
                                        icon={tab?.icon}
                                        label={bt(tab?.title)}
                                        disabled={tab?.disabled}
                                        sx={theme => ({
                                            borderRadius: "10px 10px 0px 0px",
                                            color: tab.color || theme.palette.primary.text,
                                            '&.Mui-selected': {
                                                color: tab.color || theme.palette.primary.text,
                                                borderBottom: 1,
                                                borderColor: "primary.text"
                                            },
                                            fontWeight: selectedTab === tab.id ? 'bold' : 'medium',
                                        })}
                                    />
                                    : null
                            )
                        })}
                    </Tabs>

                    <NullCheck valueForCheck={showScrollBtn && isMobile}>
                        <IconButton size="small" onClick={() => handleScroll('left')}>
                            <NavigateBefore />
                        </IconButton>
                    </NullCheck>
                </Stack>

                <NullCheck valueForCheck={divider}>
                    <Divider />
                </NullCheck>
            </Stack>
            : null
    )
}
export default CustomTabs
